module.exports = __webpack_public_path__ + "img/img_lk_brand.6b47fb76.png";